<template>
  <Loader title="Reservations">
    <!-- <div v-if="currentReservations === null">
      <h4>
        No reservations found.
      </h4>
    </div>
    <div v-if="currentReservations">
      <ReservationSelect
        :reservations="getReservationsByTime"
        v-if="!needHelp"
        v-on="{ [reservationSelectEvents.SELECT]: selectReservation }"
      />
      <BookerSelect
        :reservations="getReservationsSorted"
        v-if="needHelp"
        v-on="{ [bookerSelectEvents.SELECT]: selectReservation }"
      />
    </div> -->


    <!-- <div v-if="fullDayReservations && !actionToggle">
      <h4>
        No recent reservations found.
      </h4>
    </div> -->
    
    <ReservationSelect
      :reservations="getReservationsByTime"
      v-if="!actionToggle && currentReservations"
      v-on="{ [reservationSelectEvents.SELECT]: selectReservation }"
    />
    <BookerSelect
      :reservations="getReservationsSorted"
      v-if="actionToggle"
      v-on="{ [bookerSelectEvents.SELECT]: selectReservation }"
    />
    <b-container fluid class="mt-auto p-5" v-if="reservations">
      <b-row align-h="center">
        <b-col cols="10" class="text-center">
          <b-button variant="primary" v-on:click="toggleActionToggle">
            {{ actionText }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </Loader>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapGetters, mapState } from "vuex";
import { formatTime } from "@/utils";
import { UPDATE_SELECTED_RESERVATION, UPDATE_RESERVATIONS } from '@/store/mutations';
import { RESERVATIONS, SELECTED_RESERVATION } from "@/store/state";
import Loader from "./Loader";
import BookerSelect, { BOOKER_SELECT_EVENTS } from "@/components/BookerSelect";
import ReservationSelect, {
  RESERVATION_SELECT_EVENTS,
} from "@/components/ReservationSelect";
import { TIME_AT_LOAD } from "@/store/state";
import { FETCH_BOOKER, FETCH_RESERVATIONS_IN_RANGE } from "@/store/actions";
import { GET_RESERVATIONS_BY_TIME, GET_RESERVATIONS_SORTED } from "@/store/getters";

/**
fetch window reservations
  if none, display no reservation with need help
 */

export default {
  components: {
    ReservationSelect,
    BookerSelect,
    Loader,
  },
  data () {
    return {
      actionToggle: false,
      reservationSelectEvents: RESERVATION_SELECT_EVENTS,
      bookerSelectEvents: BOOKER_SELECT_EVENTS,
      fullDayReservations: false
    };
  },

  mounted(){
    console.log('inside mounted function');
  },
  computed: {
    ...mapState([RESERVATIONS, SELECTED_RESERVATION, TIME_AT_LOAD]),
    ...mapGetters([
      GET_RESERVATIONS_BY_TIME,
      GET_RESERVATIONS_SORTED
    ]),
    currentReservations () {
      return (!this.fullDayReservations) ? this.reservations : this.reservations;
    },
    actionText() {
      if (!this.fullDayReservations) {
        return !this.actionToggle ? 'Show Bookers' : 'Show Times'
      }
      if (this.fullDayReservations) {
        return !this.actionToggle ? 'Show All Reservations' : 'Show Recent Reservations'
      }
    },
  },
  async created() {

    const [startDatetime, endDatetime] = this.getDatetimeRange(this.timeAtLoad);
    try {
      const possibleReservations = await this.$store.dispatch(
        FETCH_RESERVATIONS_IN_RANGE,
        { start: startDatetime, end: endDatetime }
      );
      
      // possibleReservations = null;

    //   var reservationDate = moment().format('YYYY-MM-DD');
    // // console.log(process.env.VUE_APP_RESERVATIONS+"/checkin/start/"+reservationDate+"T06:00:00/end/"+reservationDate+"T23:59:00");

    // axios.get((process.env.VUE_APP_RESERVATIONS+"/checkin/start/"+reservationDate+"T06:00:00/end/"+reservationDate+"T23:59:00"),{

    //       })
    //       .then(response => 
    //       {
    //         console.log(response);
    //       })
    //       .catch(function (error){
    //         console.log(error);
    //         console.log("THERE ARE NO BOOKING");
    //       });

      if (true) {
        let curTime = moment(this.timeAtLoad);
        const afterMidnight = curTime.isBefore(this.setAbsoluteTime(curTime, {hours: 2}));
        if (afterMidnight){
          curTime = curTime.subtract(1, "days");
        }

        const dayReservations = await this.$store.dispatch(
          FETCH_RESERVATIONS_IN_RANGE,
          { 
            start: this.formatTime(moment(curTime).startOf('day')), 
            end: this.formatTime(moment(curTime).endOf('day')) 
          }
        )
        this.fullDayReservations = true
        if (!dayReservations) throw new Error(`No reservations found for today`)
      }
    } catch (err) {
      console.error(err);
      this.$store.commit(UPDATE_RESERVATIONS, null)
    }
  },
  


  methods: {
    formatTime,
    getDatetimeRange(time) {
      const mTime = moment(time);
      const possibleStart = moment(mTime).subtract(1, "hours");
      const possibleEnd = moment(mTime).add(1, "hours");

      const isBeforeTwoAM = mTime.isBefore(
        this.setAbsoluteTime(moment(mTime), { hours: 2 })
      );
      const start = isBeforeTwoAM
        ? this.setAbsoluteTime(moment(mTime).subtract(1, "days"), { hours: 23 }) // set to 11pm the day before
        : possibleStart; // else set to possibleStart

      const isAfterMidnight = possibleEnd.isAfter(
        this.setAbsoluteTime(moment(mTime), { hours: 24 })
      ); // set to today @ 24 hours -> 00:00 the next day
      const end = isAfterMidnight
        ? this.setAbsoluteTime(moment(possibleEnd), { hours: 2 }) // set time to 2am next day
        : possibleEnd; // else set to possibleEnd

      const startFormatted = this.formatTime(start);
      const endFormatted = this.formatTime(end);

      return [startFormatted, endFormatted];
    },
    nextPage () {
      this.$router.push({ name: 'Confirm' }).catch(console.error);
    },
    selectReservation(reservation) {
      const { Booker } = reservation;
      this.$store.dispatch(FETCH_BOOKER, { id: Booker.id });
      this.$store.commit(UPDATE_SELECTED_RESERVATION, reservation);
      this.nextPage();
    },
    setAbsoluteTime(time, { hours, minutes = 0, seconds = 0 }) {
      return moment(time).set({ hours, minutes, seconds });
    },
    toggleActionToggle() {
      this.actionToggle = !this.actionToggle;
    },
  },
};
</script>

<style scoped></style>
